import { connect } from "react-redux";
import moment from "moment";
import React from "react";

import {
  allottedTimeFactory,
  PRESCRIBE,
} from "@/components/Provider/ScheduleAvailability/constants";
import CardSecondary from "@/components/UI/Card/CardSecondary";
import { eventTypeDisplayNameFactory } from "@/components/Provider/ScheduleAvailability/ActiveScheduleDetails";
import InputError from "@/components/UI/InputError";
import { Select } from "@/components/UI/StyledInput";
import { testLocator } from "@/lib/helpers/test-locator";

import { GUIDED_SESSION_CPT_OPTIONS } from "../constants";
import { serviceLocationOptions } from "../../../helpers/service-location-options";

const NotesDuration = (props) => {
  const { editable, editHandler, errors, note, profileView } = props;

  const handleSelection = async (e) => {
    if (!editable) {
      return;
    }
    const newSessionTo = moment(note.session_from, "HH:mm")
      .add(allottedTimeFactory(e.target.value), "minutes")
      .format("HH:mm");

    const newNoteTitle =
      note.title.split(" - ")[0] +
      ` - (${moment(note["session_from"], "HH:mm").format("hh:mm A")}-${moment(
        newSessionTo,
        "HH:mm",
      ).format("hh:mm A")})`;

    editHandler("call_type", e.target.value, false);
    editHandler("session_to", newSessionTo, false);
    editHandler("title", newNoteTitle, false);
    editHandler("call_name", eventTypeDisplayNameFactory(e.target.value), false);
  };

  const handleServiceLocationSelection = (e) => {
    editHandler("service_location", e.target.value, false);
  };

  const options = props.profile?.provider_type
    ? GUIDED_SESSION_CPT_OPTIONS.filter((option) =>
        option.provider_types.includes(props.profile.provider_type),
      )
    : [];

  const isPrescriber = props.profile?.provider_type === PRESCRIBE;
  const innerContentTitle = `Call Duration${isPrescriber ? " and Location" : ""}`;

  let innerContent = (
    <>
      <div>
        <div className="clr-sec px-3 py-3 tw:font-bold">{innerContentTitle}</div>
      </div>
      <div className="row px-4">
        {editable && (
          <>
            <div className="col-lg-7 col-12 pb-3">
              <span className="font-weight-bold">Select CPT Code</span>
              <Select
                changeHandler={handleSelection}
                name="call_type"
                options={options}
                testId="NotesDuration_cptCode"
                value={note["call_type"]}
              />

              {errors["call_type"] ? (
                <InputError classes="custom-error">{errors["call_type"]}</InputError>
              ) : (
                ""
              )}
            </div>

            {isPrescriber && (
              <div className="col-lg-7 col-12 pb-3">
                <span className="font-weight-bold">Select Service Location</span>
                <Select
                  changeHandler={handleServiceLocationSelection}
                  name="service_location"
                  options={serviceLocationOptions}
                  value={note.service_location}
                  {...testLocator("serviceLocationSelect")}
                />
                {errors.service_location ? (
                  <InputError classes="custom-error" {...testLocator("serviceLocationError")}>
                    {errors.service_location}
                  </InputError>
                ) : (
                  ""
                )}
              </div>
            )}
          </>
        )}

        {!editable && (
          <div className="fs-12">
            <div className="col-12 mb-1">
              <div className="tw:font-bold">CPT Code</div>
              <div>{eventTypeDisplayNameFactory(note["call_type"])}</div>
            </div>
            {note.service_location && (
              <div className="col-12 mb-1">
                <div className="tw:font-bold">Service Location</div>
                <div>{note.service_location}</div>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
  let content;

  if (!profileView) {
    content = (
      <CardSecondary className="mx-0 px-3 py-3 my-3 max-width" style={{ minHeight: 200 }}>
        {innerContent}
      </CardSecondary>
    );
  } else {
    content = (
      <div className="border-top-note border-right-note" style={{ minHeight: 150 }}>
        {innerContent}
      </div>
    );
  }

  return <>{content}</>;
};

const mapStateToProps = (state) => {
  return {
    profile: state.auth.profile,
  };
};

export default connect(mapStateToProps)(NotesDuration);
